import axios from "axios";
import { DataTable } from "simple-datatables";
import { showAlert, showConfirm, handleRequestError } from "../../utils/alert";
import VMasker from "vanilla-masker"; // 🛠️ Importação adicionada

export default () => ({
  activeTab: "users",

  // Modal States
  isUserModalOpen: false,
  isRoleModalOpen: false,
  isSubmitting: false,
  hasAccessModule: true,

  // Edit States
  editMode: false,
  editId: null,

  // Data Storage
  usersList: [],
  rolesList: [],
  availableRoles: [],
  availablePermissions: [], // <-- CORREÇÃO AQUI: Declarado para o Alpine reconhecer desde o início

  // Form Payloads
  userForm: {
    name: "",
    email: "",
    password: "",
    role: "",
    default_service_commission: 0,
    default_product_commission: 0,
    discount_card_tax: false,
  },
  roleForm: { name: "", permissions: [] },

  // Instâncias das Tabelas
  usersDataTable: null,
  rolesDataTable: null,

  async initAccess() {
    const token = localStorage.getItem("jwt_token");
    if (!token) {
      window.location.href = "/client/login";
      return;
    }

    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
      // 🛠️ MÁSCARA: Aguarda o DOM renderizar e aplica regra de apenas números inteiros
      this.$nextTick(() => {
        this.initCommissionMasks();
      });

      // 🛠️ TRAVA MATEMÁTICA: Nunca deixa passar de 100%
      this.$watch("userForm.default_service_commission", (value) => {
        let num = parseInt(value);
        if (num > 100) this.userForm.default_service_commission = 100;
      });

      this.$watch("userForm.default_product_commission", (value) => {
        let num = parseInt(value);
        if (num > 100) this.userForm.default_product_commission = 100;
      });

      await this.fetchPermissions();
      await this.fetchRolesForDropdown();
      await this.loadUsersTable();
      await this.loadRolesTable();
    } catch (error) {
      // Captura o erro 403 e bloqueia a view
      if (error.response && error.response.status === 403) {
        this.hasAccessModule = false;
        return;
      }

      // Ignora se for problema de autenticação/pagamento (tratado pelo interceptor global)
      if (error.response && [401, 402].includes(error.response.status)) return;

      console.error("Infrastructure error:", error);
    }
  },

  // ================= MÁSCARAS =================
  initCommissionMasks() {
    const serviceInput = document.getElementById("service_commission_input");
    const productInput = document.getElementById("product_commission_input");

    // .maskNumber() do VMasker limpa tudo que não for número (bloqueia letras e pontos/vírgulas)
    if (serviceInput) VMasker(serviceInput).maskNumber();
    if (productInput) VMasker(productInput).maskNumber();
  },

  async fetchPermissions() {
    try {
      const response = await axios.get("/api/client/access/permissions");
      this.availablePermissions = response.data.data;
    } catch (error) {
      console.error(error);
    }
  },

  async fetchRolesForDropdown() {
    try {
      const response = await axios.get("/api/client/access/roles");
      this.availableRoles = response.data.data;
    } catch (error) {
      console.error(error);
    }
  },

  // ================= TABELAS =================
  async loadUsersTable() {
    try {
      const response = await axios.get("/api/client/access/users");
      this.usersList = response.data.data;

      if (this.usersDataTable) {
        this.usersDataTable.destroy();
      }

      const tbody = document.querySelector("#usersTable tbody");
      tbody.innerHTML = this.usersList
        .map((user) => {
          // Lógica visual para o status de desconto da taxa
          const taxBadge = user.discount_card_tax
            ? '<span class="text-[10px] font-bold text-red-600 bg-red-50 px-2 py-0.5 rounded-full border border-red-100">Desconta</span>'
            : '<span class="text-[10px] font-bold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-100">Isento</span>';

          return `
        <tr class="border-b border-gray-100 hover:bg-slate-50/50 transition-colors">
          <td class="align-middle py-3 pr-4 font-medium text-gray-900">${user.name}</td>

          <td class="align-middle py-3 pr-4 text-gray-500">${user.email}</td>

          <td class="align-middle py-3 pr-4">
            <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-[10px] font-bold text-blue-700 ring-1 ring-inset ring-blue-700/10 tracking-wider">
              ${user.role}
            </span>
          </td>

          <td class="align-middle py-3 pr-4 text-xs text-gray-700">
            <div class="flex flex-col gap-1">
              <div><span class="text-gray-400 font-medium">Serviços:</span> <span class="font-mono font-bold ml-1">${user.default_service_commission}%</span></div>
              <div><span class="text-gray-400 font-medium">Produtos:</span> <span class="font-mono font-bold ml-1">${user.default_product_commission}%</span></div>
            </div>
          </td>

          <td class="align-middle py-3 pr-4">${taxBadge}</td>

          <td class="align-middle py-3 pr-4 text-gray-500 text-sm">${user.created_at}</td>

          <td class="align-middle py-3 text-left">
            <div class="flex justify-start gap-2">
              <button
                onclick="window.dispatchEvent(new CustomEvent('edit-user', {detail: ${user.id}}))"
                class="inline-flex items-center justify-center rounded-md bg-orange-500 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-1"
              >
                Editar
              </button>
              <button
                onclick="window.dispatchEvent(new CustomEvent('delete-user', {detail: ${user.id}}))"
                class="inline-flex items-center justify-center rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-1"
              >
                Excluir
              </button>
            </div>
          </td>
        </tr>
      `;
        })
        .join("");

      this.usersDataTable = new DataTable("#usersTable", {
        searchable: false,
        perPageSelect: false,
        labels: {
          info: "Mostrando de {start} até {end} de {rows} registos",
          noRows: "Sem dados disponíveis",
          noResults: "Nenhum resultado encontrado",
        },
      });
    } catch (error) {
      console.error(error);
    }
  },

  async loadRolesTable() {
    try {
      const response = await axios.get("/api/client/access/roles");
      this.rolesList = response.data.data;

      if (this.rolesDataTable) this.rolesDataTable.destroy();

      const tbody = document.querySelector("#rolesTable tbody");
      tbody.innerHTML = this.rolesList
        .map(
          (role) => `
        <tr class="hover:bg-slate-50/50 transition-colors">
          <td class="font-bold text-gray-800 align-top py-4 px-4 xl:px-6 w-1/4 whitespace-normal">
            ${role.name}
          </td>
          <td class="align-top py-4 px-4 xl:px-6 whitespace-normal max-w-50 sm:max-w-md lg:max-w-xl">
            <div class="flex flex-wrap gap-1.5">
              ${
                !role.permissions_labels
                  ? '<span class="text-gray-400 text-sm">Sem permissões</span>'
                  : role.permissions_labels
                      .split(", ")
                      .map(
                        (p) =>
                          `<span class="inline-flex items-center rounded bg-gray-100 px-2 py-1 text-[10px] sm:text-xs font-medium text-gray-600 border border-gray-200">${p}</span>`,
                      )
                      .join("")
              }
            </div>
          </td>
          <td class="text-gray-500 align-top py-4 px-4 xl:px-6 w-1/6 whitespace-nowrap">
            ${role.created_at}
          </td>
          <td class="text-left align-top py-4 px-4 xl:px-6 w-37.5 whitespace-nowrap">
            <div class="flex justify-start gap-2">
              <button
                onclick="window.dispatchEvent(new CustomEvent('edit-role', {detail: ${role.id}}))"
                class="inline-flex items-center justify-center rounded-md bg-orange-500 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-1"
              >
                Editar
              </button>
              <button
                onclick="window.dispatchEvent(new CustomEvent('delete-role', {detail: ${role.id}}))"
                class="inline-flex items-center justify-center rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-1"
              >
                Excluir
              </button>
            </div>
          </td>
        </tr>
      `,
        )
        .join("");

      this.rolesDataTable = new DataTable("#rolesTable", {
        searchable: false,
        perPageSelect: false,
        labels: { info: "Mostrando de {start} até {end} de {rows} registos" },
      });
    } catch (error) {
      console.error(error);
    }
  },

  // ================= MODAIS =================

  openCreateUser() {
    this.editMode = false;
    this.userForm = {
      name: "",
      email: "",
      password: "",
      role: "",
      default_service_commission: 0,
      default_product_commission: 0,
      discount_card_tax: false,
    };
    this.isUserModalOpen = true;
  },

  openEditUser(id) {
    this.editMode = true;
    this.editId = id;
    const user = this.usersList.find((u) => u.id === id);
    this.userForm = {
      name: user.name,
      email: user.email,
      password: "",
      role: user.role,
      default_service_commission: user.default_service_commission || 0,
      default_product_commission: user.default_product_commission || 0,
      discount_card_tax: user.discount_card_tax || false,
    };
    this.isUserModalOpen = true;
  },

  openCreateRole() {
    this.editMode = false;
    this.roleForm = { name: "", permissions: [] };
    this.isRoleModalOpen = true;
  },

  openEditRole(id) {
    this.editMode = true;
    this.editId = id;
    const role = this.rolesList.find((r) => r.id === id);

    // Agora o Alpine usa os Nomes Técnicos reais enviados pela API (evita o Erro 422)
    this.roleForm = {
      name: role.name,
      permissions: role.permissions || [],
    };

    this.isRoleModalOpen = true;
  },

  // ================= SUBMITS (COM ALERTAS) =================

  async submitUser() {
    this.isSubmitting = true;
    try {
      if (this.editMode) {
        await axios.put(
          `/api/client/access/users/${this.editId}`,
          this.userForm,
        );
        showAlert("Usuário atualizado com sucesso!", "success");
      } else {
        await axios.post("/api/client/access/users", this.userForm);
        showAlert("Usuário criado com sucesso!", "success");
      }
      await this.loadUsersTable();
      this.isUserModalOpen = false;
    } catch (error) {
      handleRequestError(error, "Erro ao guardar o usuário.");
    } finally {
      this.isSubmitting = false;
    }
  },

  async submitRole() {
    this.isSubmitting = true;
    try {
      if (this.editMode) {
        await axios.put(
          `/api/client/access/roles/${this.editId}`,
          this.roleForm,
        );
        showAlert("Função atualizada com sucesso!", "success");
      } else {
        await axios.post("/api/client/access/roles", this.roleForm);
        showAlert("Função criada com sucesso!", "success");
      }
      await this.loadRolesTable();
      await this.fetchRolesForDropdown();
      this.isRoleModalOpen = false;
    } catch (error) {
      handleRequestError(error, "Erro ao guardar a função.");
    } finally {
      this.isSubmitting = false;
    }
  },

  // ================= EXCLUSÕES (COM SWEETALERT2) =================

  async deleteUser(id) {
    const result = await showConfirm(
      "Excluir Usuário",
      "Tem certeza que deseja excluir este usuário? Esta ação não pode ser desfeita.",
    );

    if (result.isConfirmed) {
      try {
        await axios.delete(`/api/client/access/users/${id}`);
        await this.loadUsersTable();
        showAlert("Usuário removido com sucesso.", "success");
      } catch (error) {
        handleRequestError(error, "Erro ao excluir o usuário.");
      }
    }
  },

  async deleteRole(id) {
    const result = await showConfirm(
      "Excluir Função",
      "Tem certeza que deseja excluir esta função?",
    );

    if (result.isConfirmed) {
      try {
        await axios.delete(`/api/client/access/roles/${id}`);
        await this.loadRolesTable();
        await this.fetchRolesForDropdown();
        showAlert("Função removida com sucesso.", "success");
      } catch (error) {
        handleRequestError(error, "Erro ao excluir a função.");
      }
    }
  },
});
